import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import EditSubmission from '@portal/features/submissions/EditSubmission'
import { SubmissionTitle } from '@portal/features/titles'
import { createFileRoute, useParams } from '@tanstack/react-router'

const RouteComponent = () => {
  const { surveyId } = useParams({ strict: false })

  return (
    <>
      <Header.Left>
        <BackButton to={`/surveys/${surveyId}/submissions`} />
      </Header.Left>
      <Header.Center>
        <SubmissionTitle />
      </Header.Center>
      <EditSubmission />
    </>
  )
}

export const Route = createFileRoute(
  '/_app/surveys/$surveyId/submissions_/$submissionId/'
)({
  component: RouteComponent,
})
